import React from "react";
import PropTypes from "prop-types";

export default function Map(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1546 13.0213L16.4519 9.49007C19.1011 7.31308 19.1175 3.78444 16.4884 1.62397C15.2139 0.576663 13.5143 0 11.7021 0C9.89018 0 8.19028 0.576663 6.91578 1.62397C4.793 3.36867 4.32704 6.01237 5.75759 8.20255C6.09845 8.70673 6.47979 9.13153 6.91578 9.4898L11.2131 13.0213C11.4731 13.235 11.8946 13.235 12.1546 13.0213ZM8.68793 5.36916C8.68793 4.01167 10.0318 2.90736 11.6838 2.90736C13.3358 2.90736 14.6796 4.01167 14.6796 5.36916C14.6796 6.72665 13.3357 7.83096 11.6838 7.83096C10.0318 7.83096 8.68793 6.72665 8.68793 5.36916Z"
        fill="#455060"
      />
      <path
        d="M0 22.5728V11.1502C0 10.89 0.222963 10.6658 0.533224 10.6141L3.91033 10.0504C4.12916 10.0139 4.3557 10.0699 4.5136 10.1997L7.16933 12.5117C7.29418 12.6143 7.36432 12.7534 7.36432 12.8985V20.8162C7.36432 21.0495 7.18421 21.2572 6.91578 21.3333L0.882939 23.0899C0.45059 23.2125 0 22.9486 0 22.5728Z"
        fill="#455060"
      />
      <path
        d="M11.1544 15.4227L9.65021 14.2266C9.22777 13.8906 8.5215 14.1366 8.5215 14.6197V21.0537C8.5215 21.2642 8.66854 21.4561 8.89961 21.5471L14.7248 23.8403C15.1668 24.0143 15.6782 23.7496 15.6782 23.3469V13.8533C15.6782 13.3703 14.9721 13.1243 14.5496 13.4601L12.0802 15.4228C11.822 15.628 11.4124 15.6279 11.1544 15.4227Z"
        fill="#455060"
      />
      <path
        d="M23.1426 10.149L17.617 11.5137C17.3355 11.5832 17.1429 11.7962 17.1429 12.0376V23.4526C17.1429 23.8192 17.573 24.082 18.0002 23.9765L23.5259 22.6117C23.8073 22.5422 24 22.3293 24 22.0878V10.6729C24 10.3063 23.5698 10.0434 23.1426 10.149Z"
        fill="#455060"
      />
    </svg>
  );
}

Map.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

Map.defaultProps = {
  className: "",
  width: 168,
  height: 168
};
